import { render, staticRenderFns } from "./ListPartner.vue?vue&type=template&id=1947b81f&scoped=true&"
import script from "./ListPartner.vue?vue&type=script&lang=js&"
export * from "./ListPartner.vue?vue&type=script&lang=js&"
import style0 from "./ListPartner.vue?vue&type=style&index=0&id=1947b81f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1947b81f",
  null
  
)

export default component.exports